import * as React from 'react';
import { Route, withRouter } from 'react-router-dom';
import OWAsyncRadio from '../visual_radio_input/VisualRadioInput';
import { connect } from 'react-redux';
import { locationsRestCrudThunksForBuyer } from '../../thunks/locations_thunks';
import {
	problemTypesHeirarchicalForBuyer,
	problemTypesRestCrudThunksForBuyer,
} from '../../thunks/problem_types_thunks';
import { assetsRestCrudThunksForBuyer } from '../../thunks/assets_thunks';
import { Form, Icon as LegacyIcon } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { InfoCircleOutlined, MenuOutlined } from '@ant-design/icons';
import _ from 'lodash';
import {
	Button,
	Drawer,
	Input,
	Menu,
	Modal,
	Progress,
	InputNumber,
	Popover,
	Row,
	message,
	Table,
} from 'antd';
import { getBackendUri } from '../../utils/EnvConfigUtils';
import { normFile, imageUploadValidation, imageWildcardUploadAccept } from '../../utils/ImageUtils';
import { getProtectedImageUriForBuyer } from '../../utils/FileAccessUtils';
import { TwoLineList } from '../two_line_list/TwoLineList';
import { ProtectedImageThumbnails } from '../protected_image_thumbnails/ProtectedImageThumbnails';
import { ROLE_TYPES, WO_STEP_NAMES } from '../../utils/DataConstants';
import {
	checkIsWarrantyWorkOrder,
	filterKeys,
	getWarrantyStatus,
	getFiltersFromLocation,
	nullSafeGet,
	nullSafeGetOrElse,
	getCurrency,
	getImageCountErrorRules,
	createRecordsObjectFromArray,
	mergeTroubleshootingRoutes,
	getElementAt,
	isValidNumber,
	nullSafeToFixed,
	moveObjectToBeginning,
	compareStrings,
} from '../../utils/DataAccessUtils';
import {
	getActiveAssetWarrantySupplierId,
	getActiveBuildingWarrantySupplierId,
} from '../../utils/WarrantyUtils';
import OWRadio from '../static_visual_radio_input/StaticVisualRadioInput';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import { WORK_ORDERS_CRUD_ACTION_CREATORS } from '../../actions/work_orders_actions';
import {
	workOrderPrioritiesRestCrudThunksForBuyer,
	workOrderPrioritiesWithoutPMRestCrudThunksForBuyer,
} from '../../thunks/work_order_priorities_thunks';
import { buyersRestCrudThunksForBuyer } from '../../thunks/buyers_thunks';
import {
	workOrdersRestCrudThunksForBuyer,
	findDuplicateWorkOrdersForBuyer,
	sendPreCreationAttributesForBuyer,
} from '../../thunks/work_orders_thunks';
import { buyerRoleUpdateUser } from '../../thunks/buyer_contacts_thunks';
import {
	addWarrantySupplierToStoreState,
	fetchSupplierFacilitiesInPrivateNetworkForBuyer,
	supplierFacilitiesRestCrudThunksForBuyer,
} from '../../thunks/supplier_facilities_thunks';
import { supplierPrivateNetworksV2ForBuyer } from '../../thunks/supplier_private_networks_thunks';
import SelfManagedSupplierEmailPromptModal from '../self_managed_supplier_email_prompt_modal/SelfManagedSupplierEmailPromptModal';
import {
	isSelfManagedSupplierEmailPromptEnabled,
	shouldPromptForSelfManagedSupplierEmail,
} from '../../utils/SelfManagedSupplierEmailPromptUtils';
import { workOrderAttributesRestCrudThunksForBuyer } from '../../thunks/work_order_attributes_thunks';
import { retrieveCachedUserDetails } from '../../thunks/session_thunks';
import { getBuyerCompanyApprovalTiers } from '../../thunks/company_approval_thunks';
import { BUYER_ADMIN_ONLY } from '../roles/roles';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';
import { getBackLinkStates, getQueryStringFromObject } from '../../utils/HistoryUtils';
import { getExchangeRate } from '../../thunks/currencies_thunks';
import { troubleshootingRestCrudThunksForBuyer } from '../../thunks/troubleshooting_thunks';
import TroubleshootingDisplay from '../common/TroubleshootingDisplay';
import { troubleshootingAnswersRestCrudThunksForBuyer } from '../../thunks/troubleshooting_answer_thunks';
import {
	buildAssetScopedTroubleshootingParams,
	getExistingTsAnswersFromStateForWOTsRoute,
	getTroubleshootingAnswersForNecessaryWOSteps,
	getUpdatedTroubleshootingStates,
	getUpdatedTsAnswersState,
} from '../../utils/TroubleshootingUtils';
import WorkOrderRowDisplay from '../work_order_row_display/WorkOrderRowDisplay';
import OWUpload from '../OWUpload';
import WorkOrderSummary from '../common/WorkOrderSummary';
import {
	captureDuplicateCheckRun,
	captureDuplicateResolved,
	getNewLocationNTE,
	getLocationWorkOrderAttributeFilters,
	getWorkOrderArchivalKey,
	getWorkOrderAttributeNTEInLocationCurrency,
	handleDuplicateCheckOnTitle,
	isWorkOrderDuplicationEnabled,
	logPreCreationAttributes,
	OPEN_WORK_ORDER_DISPLAY_STATUSES,
	skipAssetDuplicateCheckForKnownAsset,
	SOURCE_SURFACES,
	WIZARD_NAMES,
} from '../../utils/WorkOrderUtils';
import { areasRestCrudThunksForBuyer } from '../../thunks/areas_thunks';
import { workOrderSearchAndAPIAdaptor } from '../../thunks/work_orders_thunks_wrapper';
import { DUPLICATE_WORK_ORDER_COLUMNS } from '../duplicate_work_order_card/DuplicateWorkOrderCard';
import ResolvedImage from '../resolved_image/ResolvedImage';

require('../new_work_order_wizard_page/NewWorkOrderWizardPage.less');

interface NewWorkOrderWizardProps extends FormComponentProps {
	onSubmit: any;
	onCancel: any;
	redirectForwardUrl: any;
	saveFormData: any;
	visible: boolean;
	createErrors: any;
	updateErrors: any;
	creating: boolean;
	updating: boolean;
	location: any;
	asset: any;
	currentUser: any;
}

const DependentFieldOrder = [
	{
		key: 'problemTypeLevel1Id',
		default: undefined,
	},
	{
		key: 'problemTypeLevel2Available',
		default: false,
	},
	{
		key: 'problemTypeLevel2Id',
		default: undefined,
	},
	{
		key: 'problemTypeLevel3Available',
		default: false,
	},
	{
		key: 'problemTypeLevel3Id',
		default: undefined,
	},
	{
		key: 'problemTypeLevel4Available',
		default: false,
	},
	{
		key: 'asset',
		default: undefined,
	},
];

class NewWorkOrderWizardPage extends React.Component<any, any> {
	formRefs: any;

	getDefaultBackPath = () => {
		const { match } = this.props;
		return `/buyer/assets/detail/${match.params.id}`;
	};

	constructor(props) {
		super(props);
		this.formRefs = {};
		this.state = {
			allPhotos: [],
			willUploadPicture: false,
			uploadLoading: false,
			previewVisible: false,
			previewImage: false,
			navMenuVisible: false,
			location: {},
			problemType: {},
			woPriority: {},
			userLocation: {},
			problemTypePriorLevelId: null,
			problemTypePriorLevel: null,
			spendCategoryId: null,
			industryId: 1,
			supplier: null,
			showingAllSuppliers: false,
			approvalHeirarchy: {},
			submittedByNameIsRequired: false,
			currentRoute: '',
			assetsAvailable: false,
			workOrderAttributes: null,
			backLinkParams: '',
			backLinkTo: this.getDefaultBackPath(),
			currencyExchangeRateLocationToSupplier: 1,
			currencyExchangeRateBuyerToLocation: 1,
			troubleshootingRoutes: [],
			troubleshootingAnswers: [],
			tsAnswerUploading: false,
			isProcessing: false,
			skipSupplier: false,
			numPicturesRequired: 0,
			selfManagedSupplierEmailModalVisible: false,
			pendingSelfManagedSupplierEmailResolver: null,
			duplicateCheckSource: null as 'asset' | 'title' | null,
		};
	}

	maybePromptForSelfManagedSupplierEmail = (supplier) => {
		const { companyConfig, fetchSupplierRelationship } = this.props;
		if (!isSelfManagedSupplierEmailPromptEnabled(companyConfig)) {
			return Promise.resolve(supplier);
		}
		return fetchSupplierRelationship({ supplierFacilityId: nullSafeGet('id', supplier) })
			.then((relationships) => {
				const relationship = relationships && relationships.length > 0 ? relationships[0] : null;
				if (!shouldPromptForSelfManagedSupplierEmail(companyConfig, supplier, relationship)) {
					return supplier;
				}
				return new Promise((resolve) => {
					this.setState({
						selfManagedSupplierEmailModalVisible: true,
						pendingSelfManagedSupplierEmailResolver: resolve,
					});
				});
			})
			.catch(() => supplier);
	};

	handleSelfManagedSupplierEmailInvited = (values) => {
		const { pendingSelfManagedSupplierEmailResolver, supplier } = this.state;
		const updatedSupplier = {
			...(supplier || {}),
			primaryContactEmail: values.primaryContactEmail,
		};
		this.setState(
			{
				supplier: updatedSupplier,
				selfManagedSupplierEmailModalVisible: false,
				pendingSelfManagedSupplierEmailResolver: null,
			},
			() => {
				if (pendingSelfManagedSupplierEmailResolver) {
					pendingSelfManagedSupplierEmailResolver(updatedSupplier);
				}
			}
		);
	};

	handleSelfManagedSupplierEmailSkipped = () => {
		const { pendingSelfManagedSupplierEmailResolver, supplier } = this.state;
		this.setState(
			{
				selfManagedSupplierEmailModalVisible: false,
				pendingSelfManagedSupplierEmailResolver: null,
			},
			() => {
				if (pendingSelfManagedSupplierEmailResolver) {
					pendingSelfManagedSupplierEmailResolver(supplier);
				}
			}
		);
	};

	handleLocationChange = (locationId, loc) => {
		const { fetchLocation } = this.props;
		if (loc) {
			this.setState({
				location: loc,
				industryId: nullSafeGet('buyerCompany.industryId', loc),
			});
		} else if (locationId) {
			this.setProcessing(true);
			fetchLocation(locationId)
				.then((location) => {
					this.setState({
						location,
						industryId: nullSafeGet('buyerCompany.industryId', location),
					});
					this.setProcessing(false);
				})
				.catch(() => {
					this.setProcessing(false);
				});
		}
	};

	handleAssetLoad = (asset) => {
		const {
			fetchProblemType,
			fetchProblemTypesHierarchical,
			form,
			fetchSupplierFacilitiesInPrivateNetwork,
		} = this.props;
		if (!asset) {
			return;
		}
		const { currencyExchangeRateBuyerToLocation } = this.state;
		const assetWarrantyStatus = getWarrantyStatus(nullSafeGet('warranties.0', asset));
		const assetSupplier = nullSafeGet('warranties.0.provider.supplierFacility', asset);
		const assetWarrantyNTE = nullSafeGet('warranties.0.NTEAmount', asset);
		if (assetWarrantyStatus === 'Active' && assetWarrantyNTE) {
			this.setNTE(assetWarrantyNTE * currencyExchangeRateBuyerToLocation);
		}
		this.setState({
			asset,
			supplier:
				assetWarrantyStatus === 'Active' && assetSupplier ? assetSupplier : this.state.supplier,
		});

		const problemTypeIds = nullSafeGet('assetType.allProblemTypeIds', asset);
		const locationId = asset.locationId;
		const assetId = asset.id;
		form.setFieldsValue({
			locationId,
			assetId,
		});
		this.handleLocationChange(locationId, nullSafeGet('location', asset));
		if (problemTypeIds && problemTypeIds.length === 1) {
			const problemTypeId = problemTypeIds[0];
			this.setState({
				...this.state.initialValues,
				problemTypeId,
			});
			this.setProcessing(true);
			fetchProblemType(problemTypeId)
				.then((problemType) => {
					this.handleProblemTypeChange(problemTypeId, problemType, WO_STEP_NAMES.TITLE);
					this.setState({
						problemType,
						problemTypeTopLevelId: problemTypeId,
						problemTypePriorLevelId: problemTypeId,
						problemTypePriorLevel: problemType.name,
						spendCategoryId: problemType.spendCategoryId,
					});
				})
				.catch(() => {
					this.setProcessing(false);
				});
		} else if (problemTypeIds && problemTypeIds.length > 1) {
			this.setProcessing(true);
			fetchProblemTypesHierarchical({
				ids: problemTypeIds,
			})
				.then((problemTypes) => {
					this.setState({
						allProblemTypes: problemTypes,
						currentProblemTypes: {
							[WO_STEP_NAMES.PROBLEM_TYPE_TOP_LEVEL]: createRecordsObjectFromArray(problemTypes),
						},
					});
					this.setProcessing(false);
				})
				.catch(() => {
					this.setProcessing(false);
				});
		} else {
			this.setProcessing(true);
			fetchProblemTypesHierarchical()
				.then((problemTypes) => {
					this.setState({
						allProblemTypes: problemTypes,
						currentProblemTypes: {
							[WO_STEP_NAMES.PROBLEM_TYPE_TOP_LEVEL]: createRecordsObjectFromArray(problemTypes),
						},
					});
					this.setProcessing(false);
				})
				.catch(() => {
					this.setProcessing(false);
				});
		}
	};

	componentDidMount() {
		document.body.classList.add('newWorkOrderWizardBody');
		const {
			fetchArea,
			fetchAsset,
			match,
			fetchBuyer,
			currentUser,
			fetchApprovalHeirarchy,
			location,
		} = this.props;
		const urlParams = new URLSearchParams(location.search);
		const { supplier } = this.state;

		this.setState(getBackLinkStates(location, this.getDefaultBackPath()));

		fetchBuyer(nullSafeGet('facility.buyerCompanyId', currentUser)).then((buyer) => {
			this.setState({ industryId: buyer.industryId });
		});

		if (nullSafeGetOrElse('isSharedContact', currentUser, false)) {
			this.setState({ submittedByNameIsRequired: true });
		}

		const assetId = match.params.id;

		this.setProcessing(true);
		fetchAsset(assetId)
			.then((asset) => {
				this.handleAssetLoad(asset);
				this.goNext([], WO_STEP_NAMES.ASSET_CONDITION, WO_STEP_NAMES.ASSET);
				// history.push(`/buyer/assets/${assetId}/newWorkOrder/${WO_STEP_NAMES.ASSET_CONDITION}`);
			})
			.catch(() => {
				this.setProcessing(false);
			});

		fetchApprovalHeirarchy().then((data) => {
			const tiers = nullSafeGet('0.tierDetails', data);
			if (tiers && tiers.length > 0) {
				const userTier =
					_.find(tiers, (item) => _.find(item.approvers, { email: currentUser.email })) || tiers[0];
				this.setState({
					approvalHeirarchy: { amount: userTier.amountUpto || 1000000000 },
				});
			}
		});

		//Normally on Handle Location Change (but since no location change, handle here)
		new Promise((resolve, reject) => {
			resolve(this.checkBuyerToLocationCurrencyChange(location));
		}).then(() => {
			this.checkCurrencyChange(location, supplier);
		});

		if (urlParams.get('areaId')) {
			fetchArea(urlParams.get('areaId')).then((data) => this.setState({ area: data }));
		}
	}

	checkBuyerToLocationCurrencyChange = (location) => {
		const { currentUser, fetchExchangeRate } = this.props;

		const locationCurrencyId = getCurrency({ location }).id;
		const buyerCurrencyId = getCurrency({ currentUser }).id;
		if (locationCurrencyId !== buyerCurrencyId) {
			fetchExchangeRate(locationCurrencyId, buyerCurrencyId, currentUser.contactType).then(
				(rate) => {
					this.setState({
						currencyExchangeRateBuyerToLocation: nullSafeGetOrElse('conversionRate', rate, 1),
					});
				}
			);
		} else {
			this.setState({ currencyExchangeRateBuyerToLocation: 1 });
		}
	};

	checkCurrencyChange = (location, supplierFacility) => {
		const { currentUser, fetchExchangeRate } = this.props;

		const locationCurrency = getCurrency({ location });
		const supplierCurrency = getCurrency({ supplier: supplierFacility });
		if (supplierCurrency && locationCurrency && locationCurrency.id !== supplierCurrency.id) {
			fetchExchangeRate(supplierCurrency.id, locationCurrency.id, currentUser.contactType).then(
				(rate) =>
					this.setState(
						{
							exchangeRate: nullSafeGetOrElse('conversionRate', rate, 1),
						},
						() => {
							this.resetNTE();
						}
					)
			);
		} else {
			this.resetNTE();
		}
	};

	assetWarranty = () => {
		const { asset, supplierFacilityId } = this.state;
		const assetWarrantyStatus = getWarrantyStatus(nullSafeGet('warranties.0', asset));
		const assetSupplierId = nullSafeGet('warranties.0.provider.supplierFacilityId', asset);
		const assetWarrantyNTE = nullSafeGet('warranties.0.NTEAmount', asset);

		return (
			assetWarrantyStatus === 'Active' && assetSupplierId === supplierFacilityId && assetWarrantyNTE
		);
	};

	isWorkOrderSupplierPrivate = () => {
		const { supplier, supplierFacilityId } = this.state;
		return supplierFacilityId && nullSafeGetOrElse('status', supplier, 'private') === 'private';
	};

	//When some field has changed (supplier/asset/problem type), check what NTE should be.
	resetNTE = () => {
		const { form } = this.props;
		const {
			exchangeRate,
			locationNTE,
			workOrderAttributesNTE,
			supplier,
			currencyExchangeRateBuyerToLocation,
		} = this.state;

		const assetWarrantyNTE = this.assetWarranty();
		const hasSupplier = supplier && supplier.id !== undefined;

		const newLocationNTE = getNewLocationNTE(
			hasSupplier,
			this.isWorkOrderSupplierPrivate(),
			assetWarrantyNTE,
			locationNTE,
			workOrderAttributesNTE,
			currencyExchangeRateBuyerToLocation
		);
		this.setState(
			{
				currentNTE:
					isValidNumber(newLocationNTE) && isValidNumber(exchangeRate)
						? newLocationNTE * exchangeRate
						: undefined,
				locationNTE: newLocationNTE,
			},
			() => {
				form.setFieldsValue({
					nteInLocationCurrency: nullSafeToFixed(newLocationNTE),
				});
			}
		);
	};

	toggleShowingAll() {
		this.setState({ showingAllSuppliers: !this.state.showingAllSuppliers });
	}

	componentWillUnmount() {
		document.body.classList.remove('newWorkOrderWizardBody');
		const { clearFormData } = this.props;
		clearFormData();
	}

	isProcessing = () => {
		const { creating } = this.props;
		return creating || this.state.isProcessing || this.state.tsAnswerUploading;
	};

	setProcessing = (isProcessing) => {
		this.setState({ isProcessing });
	};

	removeTroubleshootingRoutes = (currentRoute) => {
		const routeHierarchy = [
			WO_STEP_NAMES.ASSET_CONDITION,
			WO_STEP_NAMES.PROBLEM_TYPE_TOP_LEVEL,
			WO_STEP_NAMES.PROBLEM_TYPE_NEXT_LEVEL,
			WO_STEP_NAMES.PROBLEM_TYPE_NEXT_BRANCH,
			WO_STEP_NAMES.PRIORITY,
			WO_STEP_NAMES.SUPPLIER,
		];
		this.setState(getUpdatedTroubleshootingStates(routeHierarchy, currentRoute, this.state));
	};

	onRouteChanged = () => {
		const pathName = nullSafeGetOrElse('props.location.pathname', this, '');
		const currentRoute = getElementAt(pathName.split('/'), -1);
		this.removeTroubleshootingRoutes(currentRoute);
		const params = getFiltersFromLocation(this.props.location);
		const allowedStateKeys = [
			'problemTypeLevel2Available',
			'problemTypeLevel3Available',
			'problemTypePriorLevelId',
			'problemTypePriorLevel',
			'spendCategoryId',
		];
		const newState = {
			...filterKeys(params, allowedStateKeys, true),
			currentRoute,
		};
		this.setState(newState);
	};

	getTroubleshootingParams = (previousStep) => {
		return buildAssetScopedTroubleshootingParams(
			{
				locationId: nullSafeGet('state.location.id', this),
				problemTypeId: nullSafeGet('state.problemType.id', this),
				assetId: nullSafeGet('state.asset.id', this),
				assetTypeId: nullSafeGet('state.asset.assetTypeId', this),
				workOrderPriorityId: nullSafeGet('state.woPriority.id', this),
				supplierFacilityId: nullSafeGet('state.supplier.facility.id', this),
			},
			previousStep
		);
	};

	checkTroubleShooting = (args, previousStep) => {
		const { fetchTroubleshooting } = this.props;
		const params = this.getTroubleshootingParams(previousStep);
		if (!Object.keys(params).length) {
			this.proceedToNextStep(args);
			return Promise.resolve();
		}
		return fetchTroubleshooting(params)
			.then((res) => {
				if (res && res.length > 0) {
					const existingTroubleshootingRoutes = nullSafeGetOrElse(
						'state.troubleshootingRoutes',
						this,
						[]
					);
					if (existingTroubleshootingRoutes.find((_) => _.id === res[0].id)) {
						this.proceedToNextStep(args);
					} else {
						this.setState({
							troubleshootingRoutes: [
								...existingTroubleshootingRoutes,
								...[
									{
										...res[0],
										args,
										previousStep,
									},
								],
							],
						});
						this.proceedToNextStep({
							validationSteps: [],
							destination: `troubleshooting-${res[0].id}`,
						});
					}
				} else {
					this.proceedToNextStep(args);
				}
			})
			.catch(() => {
				this.setProcessing(false);
			});
	};

	componentDidUpdate(prevProps): void {
		if (this.props.location !== prevProps.location) {
			this.onRouteChanged();
		}
	}

	updateTroubleshootingAnswerIfAvailable = (workOrder) => {
		const { createTroubleshootingAnswersBulk, deleteWorkOrderFromRedux } = this.props;
		const answers = nullSafeGetOrElse('troubleshootingAnswers', this.state, []);
		return new Promise((resolve, reject) => {
			if (answers.length > 0) {
				this.setState({ tsAnswerUploading: true });
				createTroubleshootingAnswersBulk(
					answers.map((_) => ({
						..._,
						workOrderId: workOrder.id,
					}))
				)
					.then((res) => {
						deleteWorkOrderFromRedux(workOrder);
						resolve(res);
					})
					.catch((err) => {
						message.error(err);
						reject(err);
					})
					.finally(() => this.setState({ tsAnswerUploading: false }));
			} else {
				resolve(true);
			}
		});
	};

	handleSubmit = () => {
		const { form, formData, history, currentUser, submitWorkOrderForm } = this.props;
		const { location, currencyExchangeRateLocationToSupplier, supplier } = this.state;
		form.validateFields((err, values) => {
			if (!err) {
				// put image data into proper format to persist
				const picturesInfo = this.state.allPhotos.map((p) => {
					const fileName = nullSafeGetOrElse('response.data.fileName', p, '');
					const fileId = nullSafeGetOrElse('response.data.fileId', p, '');
					return `${fileId}/${fileName}`;
				});

				const contractorDetails = {
					contractorContacts: [],
				};
				const locationCurrencyId = getCurrency({ location }).id;
				const supplierCurrencyId = getCurrency({ supplier }).id;

				const DEFAULT_SPEND_CATEGORY = '17';

				const workOrder = {
					title: values.title,
					woPriorityId: nullSafeGet('id', this.state.woPriority)
						? parseInt(nullSafeGet('id', this.state.woPriority), 10)
						: null,
					problemTypeId: nullSafeGet('id', this.state.problemType)
						? parseInt(nullSafeGet('id', this.state.problemType), 10)
						: null,
					spendCategoryId: parseInt(
						nullSafeGetOrElse('spendCategoryId', this.state, DEFAULT_SPEND_CATEGORY),
						10
					),
					locationId: parseInt(nullSafeGetOrElse('state.location.id', this, -1), 10),
					areaId: nullSafeGet('areaId', this.state.asset)
						? parseInt(nullSafeGet('areaId', this.state.asset), 10)
						: undefined,
					assetId: formData.assetId ? parseInt(formData.assetId, 10) : null,
					...(formData.assetId && {
						isAssetDown: formData.isAssetDown === 'true' ? true : false,
					}),
					images: picturesInfo,
					currencyExchangeRateLocationToSupplier: currencyExchangeRateLocationToSupplier,
					nte: this.state.nte * currencyExchangeRateLocationToSupplier,
					currencyId: supplierCurrencyId,
					nteInLocationCurrency: formData.nte ? parseFloat(formData.nte) : undefined,
					locationCurrencyId: locationCurrencyId,
					description: formData.additionalInfo,
					buyerFacilityId: nullSafeGet('buyerFacilityId', location),
					buyerCompanyId: values.buyerCompanyId,
					createdBy: currentUser.email,
					supplierFacilityId: nullSafeGet('id', this.state.supplier)
						? parseInt(nullSafeGet('id', this.state.supplier), 10)
						: null,
					contractorDetails: contractorDetails,
					submittedByName: formData.submittedByName,
					notes: [],
					buyerAttachments: formData.buyerAttachments,
					isWarranty: checkIsWarrantyWorkOrder(
						nullSafeGet('asset.warranties.0', this.state),
						nullSafeGet('id', this.state.supplier)
					),
					skipSupplier: this.state.skipSupplier,
				};

				submitWorkOrderForm(workOrder).then((rec) => {
					logPreCreationAttributes({
						state: this.state,
						currentUser: this.props.currentUser,
						sendPreCreationAttributesFn: sendPreCreationAttributesForBuyer,
						source: SOURCE_SURFACES.ASSET,
						createdWorkOrderId: parseInt(rec.id, 10),
					});
					this.updateTroubleshootingAnswerIfAvailable(rec).then(() =>
						history.push(
							`/buyer/workOrders/detail/${rec.id}/details`.concat('?', this.state.backLinkParams)
						)
					);
				});
			}
		});
	};

	proceedToNextStep = (values) => {
		const { validationSteps, destination, useReplace = false, params = {} } = values;
		const { form, history, match } = this.props;
		const assetId = match.params.id;
		return new Promise<void>((resolve, reject) => {
			form.validateFields(validationSteps, (err) => {
				if (err) {
					console.log(err);
					this.setProcessing(false);
					reject(err);
					return;
				}
				window.scrollTo(0, 0);
				const navigateFunction = useReplace ? history.replace : history.push;
				const queryString = getQueryStringFromObject(params);
				const navigateTo = `/buyer/assets/${assetId}/newWorkOrder/${destination}${
					queryString ? `?${queryString}` : ''
				}`;
				navigateFunction(navigateTo);
				this.setProcessing(false);
				resolve();
			});
		});
	};

	goNext = (
		validationSteps,
		destination,
		stepName,
		ingnoreTroubleshooting = false,
		useReplace = false,
		params = {}
	) => {
		this.setProcessing(true);
		const args = {
			validationSteps,
			destination,
			useReplace,
			params,
		};

		const requiredSteps = [
			WO_STEP_NAMES.ASSET_CONDITION,
			WO_STEP_NAMES.PROBLEM_TYPE_TOP_LEVEL,
			WO_STEP_NAMES.PROBLEM_TYPE_NEXT_LEVEL,
			WO_STEP_NAMES.PROBLEM_TYPE_NEXT_BRANCH,
			WO_STEP_NAMES.PRIORITY,
			WO_STEP_NAMES.SUPPLIER,
		];

		if (!ingnoreTroubleshooting && requiredSteps.includes(stepName)) {
			const result = this.checkTroubleShooting(args, stepName);
			if (result && typeof result.then === 'function') {
				return result.finally(() => {
					this.setProcessing(false);
				});
			}
			this.setProcessing(false);
			return result;
		} else {
			const result = this.proceedToNextStep(args);
			if (result && typeof result.then === 'function') {
				return result.finally(() => {
					this.setProcessing(false);
				});
			}
			this.setProcessing(false);
			return result;
		}
	};

	cancelRequest = () => this.props.history.push(this.state.backLinkTo);

	goBack = () => {
		const { history } = this.props;
		history.goBack();
	};

	goNextAfterBriefPause = (
		validationSteps,
		destination,
		currentStep,
		ignoreTroubleshooting = false
	) => {
		this.setProcessing(true);
		return new Promise((resolve, reject) => {
			setTimeout(() => {
				try {
					const result = this.goNext(
						validationSteps,
						destination,
						currentStep,
						ignoreTroubleshooting
					);
					if (result && typeof result.then === 'function') {
						result.then(resolve).catch((error) => {
							this.setProcessing(false);
							reject(error);
						});
					} else {
						this.setProcessing(false);
						resolve(result);
					}
				} catch (error) {
					this.setProcessing(false);
					reject(error);
				}
			}, 350);
		});
	};

	resetFieldAFter = (changedState) => {
		const index = DependentFieldOrder.findIndex((_) => _.key === changedState);
		const newState =
			index > -1
				? DependentFieldOrder.slice(index + 1).reduce((obj, field) => {
						obj[field.key] = field.default;
						return obj;
				  }, {})
				: {};
		this.setState(newState);
	};

	changeId = (key, value) => {
		this.setState({ [key]: value });
		this.resetFieldAFter(key);
	};

	handlePreview = (obj) => {
		let thumbUrl = null;
		let fullUrl = null;
		let photoInfo = null;
		if (obj.response.data) {
			const imgFileId = obj.response.data.fileId;
			const imgFileName = obj.response.data.fileName;
			thumbUrl = getProtectedImageUriForBuyer(imgFileId, imgFileName, 100, 100);
			fullUrl = getProtectedImageUriForBuyer(imgFileId, imgFileName, 800, 800);
			photoInfo = {
				uid: imgFileId,
				size: 1,
				name: imgFileName,
				filename: imgFileName,
				url: fullUrl,
				status: 'done',
				thumbUrl: thumbUrl,
				response: { data: { fileName: imgFileName, fileId: imgFileId } },
				type: 'image',
			};
		}
		this.setState({
			photoInfo: [photoInfo],
			previewImage: fullUrl || thumbUrl,
			previewVisible: true,
		});
	};

	handleImageUpdate = (info) => {
		this.setState({ allPhotos: info.fileList.filter((img) => img.status === 'done') });
	};

	getProblemType = (problemTypeId) => {
		const allProblemTypes = nullSafeGetOrElse('state.allProblemTypes', this, []);

		const find = (pts) => {
			return pts.reduce((acc, _) => {
				// eslint-disable-next-line eqeqeq
				if (_.id == problemTypeId) {
					return {
						...acc,
						..._,
					};
				} else if (nullSafeGetOrElse('children', _, []).length > 0) {
					return { ...acc, ...find(_.children) };
				} else {
					return acc;
				}
			}, {});
		};

		return find(allProblemTypes);
	};

	handleProblemTypeChange = (problemTypeId, problemType, nextStep) => {
		if (problemType.hasChildren) {
			this.setState({
				currentProblemTypes: {
					...this.state.currentProblemTypes,
					[nextStep]: createRecordsObjectFromArray(problemType.children),
				},
			});
		}
		this.setState({
			problemType,
			problemTypePriorLevelId: problemTypeId,
			problemTypePriorLevel: problemType.hierarchyName,
			spendCategoryId: problemType.spendCategoryId,
			numPicturesRequired: nullSafeGetOrElse('serviceRequestNumPicturesRequired', problemType, 0),
		});
		if (problemTypeId) {
			const {
				fetchWorkOrderAttributes,
				fetchWorkOrderPriority,
				fetchSupplierFacilitiesInPrivateNetwork,
			} = this.props;
			if (problemTypeId) {
				this.setProcessing(true);
				const supplierFacilitiesPromise = fetchSupplierFacilitiesInPrivateNetwork({
					problemTypeId,
					locationId: nullSafeGet('id', this.state.location),
				});
				const workOrderAttributePromise = fetchWorkOrderAttributes({
					problemTypeId,
					...getLocationWorkOrderAttributeFilters(this.state.location, this.state.area),
				});

				return new Promise((resolve, reject) => {
					Promise.all([supplierFacilitiesPromise, workOrderAttributePromise])
						.then((values) => {
							const { asset, currencyExchangeRateBuyerToLocation } = this.state;
							const assetWarrantyStatus = getWarrantyStatus(nullSafeGet('warranties.0', asset));
							const assetSupplier = nullSafeGet('warranties.0.provider.supplierFacility', asset);
							const assetWarrantyNTE = nullSafeGet('warranties.0.NTEAmount', asset);
							const supplierFacility = values[0];
							if (compareStrings(assetWarrantyStatus, 'Active') && assetWarrantyNTE) {
								this.setNTE(assetWarrantyNTE * currencyExchangeRateBuyerToLocation);
								this.setState({
									supplier:
										compareStrings(assetWarrantyStatus, 'Active') && assetSupplier
											? assetSupplier
											: this.state.supplier,
								});
							} else if (supplierFacility.length > 0) {
								this.setState({ supplier: supplierFacility[0] });
							} else {
								this.setState({ supplier: null });
							}

							const workOrderAttributes = values[1];
							this.setState({ workOrderAttributes });
							if (nullSafeGetOrElse('length', workOrderAttributes, 0) > 0) {
								if (workOrderAttributes[0].NTEAmount) {
									this.setNTE(workOrderAttributes[0].NTEAmount);
								}
								if (workOrderAttributes[0].workOrderPriorityId) {
									fetchWorkOrderPriority(workOrderAttributes[0].workOrderPriorityId).then(
										(workOrderPriority) => this.setState({ woPriority: workOrderPriority })
									);
								}
								if (
									workOrderAttributes[0].workOrderTitle &&
									!this.props.form.getFieldValue('title')
								) {
									this.props.form.setFieldsValue({ title: workOrderAttributes[0].workOrderTitle });
								}
							}

							this.setProcessing(false);
							resolve(problemType);
						})
						.catch((err) => {
							this.setProcessing(false);
							reject(err);
						});
				});
			}
		}
	};

	handleProblemTypeTopLevelChange = (problemTypeId) => {
		const problemType = this.getProblemType(problemTypeId);
		this.setProcessing(true);
		this.handleProblemTypeChange(problemTypeId, problemType, WO_STEP_NAMES.PROBLEM_TYPE_NEXT_LEVEL)
			.then(() => {
				this.setState(
					{
						problemTypeTopLevelId: problemTypeId,
					},
					() => {
						if (problemType && problemType.hasChildren) {
							this.setState({ problemTypeLevel2Available: true });
							this.goNext(
								[],
								WO_STEP_NAMES.PROBLEM_TYPE_NEXT_LEVEL,
								WO_STEP_NAMES.PROBLEM_TYPE_TOP_LEVEL
							);
						} else {
							this.setState({ problemTypeLevel2Available: false });
							this.goNext([], WO_STEP_NAMES.TITLE, WO_STEP_NAMES.PROBLEM_TYPE_TOP_LEVEL);
						}
					}
				);
			})
			.catch(() => {
				this.setProcessing(false);
			});
	};

	handleProblemTypeNextLevelChange = (problemTypeId) => {
		const problemType = this.getProblemType(problemTypeId);
		this.setProcessing(true);
		this.handleProblemTypeChange(problemTypeId, problemType, WO_STEP_NAMES.PROBLEM_TYPE_NEXT_BRANCH)
			.then(() => {
				if (problemType.hasChildren) {
					this.setState({
						problemTypeLevel3Available: problemType.hasChildren,
					});
					this.goNext(
						[],
						WO_STEP_NAMES.PROBLEM_TYPE_NEXT_BRANCH,
						WO_STEP_NAMES.PROBLEM_TYPE_NEXT_LEVEL
					);
				} else {
					this.setState({
						problemTypeLevel3Available: false,
					});
					this.goNext([], WO_STEP_NAMES.TITLE, WO_STEP_NAMES.PROBLEM_TYPE_NEXT_LEVEL);
				}
			})
			.catch(() => {
				this.setProcessing(false);
			});
	};

	handleProblemTypeNextLevelBranchChange = (problemTypeId) => {
		const problemType = this.getProblemType(problemTypeId);
		this.setProcessing(true);
		this.handleProblemTypeChange(problemTypeId, problemType, WO_STEP_NAMES.PROBLEM_TYPE_NEXT_BRANCH)
			.then(() => {
				if (problemType.hasChildren) {
					this.goNext(
						[],
						WO_STEP_NAMES.PROBLEM_TYPE_NEXT_BRANCH,
						WO_STEP_NAMES.PROBLEM_TYPE_NEXT_LEVEL
					);
				} else {
					this.goNext([], WO_STEP_NAMES.TITLE, WO_STEP_NAMES.PROBLEM_TYPE_NEXT_LEVEL);
				}
			})
			.catch(() => {
				this.setProcessing(false);
			});
	};

	checkForSharedContactAndMoveToNextStep = (validation, currentStep) => {
		const { currentUser } = this.props;
		nullSafeGetOrElse('isSharedContact', currentUser, false)
			? this.goNextAfterBriefPause(validation, WO_STEP_NAMES.SUBMITTED_BY, currentStep)
			: this.goNextAfterBriefPause(validation, WO_STEP_NAMES.COMPLETION, currentStep);
	};

	handleWorkOrderPriority = (woPriorityId) => {
		const { fetchWorkOrderPriority } = this.props;
		this.setProcessing(true);
		fetchWorkOrderPriority(woPriorityId)
			.then((woPriority) => {
				this.setState({ woPriority }, () => {
					this.goNextAfterBriefPause([], WO_STEP_NAMES.SUPPLIER, WO_STEP_NAMES.PRIORITY);
				});
			})
			.finally(() => {
				this.setProcessing(false);
			});
	};

	handleWorkOrderPriorityClick = (woPriorityId) => {
		const { fetchWorkOrderPriority } = this.props;
		this.setProcessing(true);
		fetchWorkOrderPriority(woPriorityId)
			.then((woPriority) => {
				this.setState({ woPriority }, () => {
					this.goNext([], WO_STEP_NAMES.SUPPLIER, WO_STEP_NAMES.PRIORITY);
				});
			})
			.finally(() => {
				this.setProcessing(false);
			});
	};
	setNTE = (nte) => {
		const { form } = this.props;
		this.setState({ nte });
		form.setFieldsValue({
			nte: nte ? parseFloat(nte).toFixed(2) : undefined,
		});
	};

	setDefaultNTE = (supplierFacilityId) => {
		const { form } = this.props;
		const {
			workOrderAttributes = [],
			asset,
			supplier = {},
			currencyExchangeRateBuyerToLocation,
		} = this.state;
		if (
			checkIsWarrantyWorkOrder(nullSafeGet('warranties.0', asset), parseInt(supplierFacilityId)) &&
			nullSafeGet('warranties.0.NTEAmount', asset)
		) {
			this.setNTE(
				nullSafeGet('warranties.0.NTEAmount', asset) * currencyExchangeRateBuyerToLocation
			);
		} else if (supplier.status === 'private') {
			this.setNTE(null);
		} else {
			if (nullSafeGetOrElse('length', workOrderAttributes, 0) > 0) {
				if (workOrderAttributes[0].NTEAmount) {
					const { fetchExchangeRate, currentUser } = this.props;
					getWorkOrderAttributeNTEInLocationCurrency(
						workOrderAttributes[0],
						this.state.location,
						fetchExchangeRate,
						nullSafeGet('contactType', currentUser)
					).then((nte) => this.setNTE(nte));
				}
			}
		}
	};

	handleNTESubmit = () => {
		const { formData } = this.props;
		this.setNTE(formData.nte);
	};

	handleSupplierChange = (facilityId?: any) => {
		const { fetchSupplierFacility, fetchExchangeRate, currentUser } = this.props;
		const {
			location,
			supplier = {},
			workOrderAttributes = [],
			currencyExchangeRateBuyerToLocation,
		} = this.state;
		!!facilityId && this.setState({ skipSupplier: false });
		const supplierFacilityId = facilityId || nullSafeGet('id', supplier);
		if (supplierFacilityId) {
			this.setProcessing(true);
			fetchSupplierFacility(supplierFacilityId)
				.then((supplier) => {
					this.setState(
						{
							supplier,
						},
						() => {
							this.maybePromptForSelfManagedSupplierEmail(supplier).then((effectiveSupplier) => {
								if (!effectiveSupplier) {
									this.setProcessing(false);
									return;
								}
								const locationCurrencyId = getCurrency({ location }).id;
								const supplierCurrencyId = getCurrency({ supplier: effectiveSupplier }).id;
								if (locationCurrencyId !== supplierCurrencyId) {
									fetchExchangeRate(supplierCurrencyId, locationCurrencyId, currentUser.contactType)
										.then((rate) => {
											this.setState({
												currencyExchangeRateLocationToSupplier: nullSafeGetOrElse(
													'conversionRate',
													rate,
													1
												),
											});
											this.setDefaultNTE(supplierFacilityId);
										})
										.catch(() => {
											this.setProcessing(false);
										});
								} else {
									this.setState({ currencyExchangeRateLocationToSupplier: 1 });
									this.setDefaultNTE(supplierFacilityId);
								}
								if (effectiveSupplier.status === 'private') {
									this.setNTE(undefined);
									this.checkForSharedContactAndMoveToNextStep([], WO_STEP_NAMES.SUPPLIER);
								} else {
									this.goNextAfterBriefPause([], WO_STEP_NAMES.NTE, WO_STEP_NAMES.SUPPLIER);
								}
							});
						}
					);
				})
				.catch(() => {
					this.setProcessing(false);
				});
		} else {
			this.goNextAfterBriefPause([], WO_STEP_NAMES.NTE, WO_STEP_NAMES.SUPPLIER);
		}
	};

	handleAssetCondition = () => {
		const { asset } = this.state;
		if (isWorkOrderDuplicationEnabled()) {
			skipAssetDuplicateCheckForKnownAsset({
				asset,
				goNextAfterBriefPause: this.goNextAfterBriefPause,
			});
			return;
		}
		const problemTypeIds = nullSafeGet('assetType.allProblemTypeIds', asset);
		const { fetchWorkOrders, currentUser } = this.props;
		this.setProcessing(true);
		fetchWorkOrders({
			assetId: nullSafeGet('id', asset),
			locationId: nullSafeGet('location.id', this.state),
			isPM: false,
			displayStatuses: OPEN_WORK_ORDER_DISPLAY_STATUSES,
			[getWorkOrderArchivalKey(currentUser)]: false,
		})
			.then((workOrders) => {
				captureDuplicateCheckRun({
					wizard: WIZARD_NAMES.ASSET_NEW_WORK_ORDER,
					source: 'asset',
					rawWorkOrders: workOrders,
					shownWorkOrders: workOrders,
					context: {
						locationId: nullSafeGet('location.id', this.state),
						assetId: nullSafeGet('id', asset),
					},
				});
				if (!workOrders || workOrders.length === 0) {
					if (problemTypeIds && problemTypeIds.length === 1) {
						this.goNextAfterBriefPause([], WO_STEP_NAMES.TITLE, WO_STEP_NAMES.ASSET_CONDITION);
					} else {
						this.goNextAfterBriefPause(
							[],
							WO_STEP_NAMES.PROBLEM_TYPE_TOP_LEVEL,
							WO_STEP_NAMES.ASSET_CONDITION
						);
					}
				} else {
					this.setState({ duplicateWorkOrders: workOrders, duplicateCheckSource: 'asset' });
					this.goNext([], WO_STEP_NAMES.DUPLICATE_CHECK, WO_STEP_NAMES.ASSET_CONDITION);
				}
			})
			.catch(() => {
				this.setProcessing(false);
			});
	};

	handleTitle = () =>
		handleDuplicateCheckOnTitle({
			state: this.state,
			form: this.props.form,
			currentUser: this.props.currentUser,
			findDuplicateWorkOrders: this.props.findDuplicateWorkOrders,
			setState: (state) => this.setState(state),
			setProcessing: this.setProcessing,
			goNext: this.goNext,
			goNextAfterBriefPause: this.goNextAfterBriefPause,
			wizard: WIZARD_NAMES.ASSET_NEW_WORK_ORDER,
		});

	handleDuplicate = (resp) => {
		captureDuplicateResolved({
			wizard: WIZARD_NAMES.ASSET_NEW_WORK_ORDER,
			source: this.state.duplicateCheckSource,
			resp,
			shownCount: nullSafeGetOrElse('duplicateWorkOrders.length', this.state, 0),
		});
		const { asset } = this.state;
		const problemTypeIds = nullSafeGet('assetType.allProblemTypeIds', asset);
		if (resp == 1) {
			this.cancelRequest();
			logPreCreationAttributes({
				state: this.state,
				currentUser: this.props.currentUser,
				sendPreCreationAttributesFn: sendPreCreationAttributesForBuyer,
				source: SOURCE_SURFACES.ASSET,
				duplicateWorkOrderId: parseInt(nullSafeGet('duplicateWorkOrders.0.id', this.state), 10),
			});
		} else {
			if (this.state.duplicateCheckSource === 'title') {
				this.goNextAfterBriefPause([], 'photos', WO_STEP_NAMES.DUPLICATE_CHECK);
			} else if (problemTypeIds && problemTypeIds.length === 1) {
				this.goNextAfterBriefPause([], WO_STEP_NAMES.TITLE, WO_STEP_NAMES.DUPLICATE_CHECK);
			} else {
				this.goNextAfterBriefPause(
					[],
					WO_STEP_NAMES.PROBLEM_TYPE_TOP_LEVEL,
					WO_STEP_NAMES.DUPLICATE_CHECK
				);
			}
		}
	};

	handleNavMenuClose = () => {
		this.setState({ navMenuVisible: false });
	};

	handleNavMenuOpen = () => {
		this.setState({ navMenuVisible: true });
	};

	handleNavMenuClick = (e) => {
		const methods = {
			problemTypeNextLevel: () =>
				this.handleProblemTypeTopLevelChange(this.state.problemTypeLevel1Id),
			problemTypeNextBranch: () =>
				this.handleProblemTypeNextLevelChange(this.state.problemTypeLevel2Id),
		};
		methods[e.key] ? methods[e.key]() : this.goNext([], e.key, '', true);
	};

	handleCancel = () => this.setState({ previewVisible: false });

	isTroubleshootingAllowedToProceed = (checkSteps) => {
		const tsRoutes = nullSafeGetOrElse('state.troubleshootingRoutes', this, []);
		const allowedToProceed =
			tsRoutes
				.filter((_) => checkSteps.includes(_.previousStep))
				.filter((_) => !nullSafeGetOrElse('troubleshootingSteps', _, [{}])[0].canProceedToNextStep)
				.length === 0;

		return allowedToProceed;
	};

	isProblemTypeAndAssetSelected = () => {
		const {
			problemTypeLevel1Id,
			problemTypeLevel2Available,
			problemTypeLevel2Id,
			problemTypeLevel3Available,
			problemTypeLevel3Id,
		} = this.state;
		const problemTypeSelected = problemTypeLevel1Id
			? problemTypeLevel2Available
				? problemTypeLevel2Id
					? problemTypeLevel3Available
						? problemTypeLevel3Id
							? true
							: false
						: true
					: false
				: true
			: false;

		const checkSteps = [
			WO_STEP_NAMES.PROBLEM_TYPE_TOP_LEVEL,
			WO_STEP_NAMES.PROBLEM_TYPE_NEXT_LEVEL,
			WO_STEP_NAMES.PROBLEM_TYPE_NEXT_BRANCH,
		];
		return problemTypeSelected && this.isTroubleshootingAllowedToProceed(checkSteps);
	};

	isPrioritySelected = () =>
		nullSafeGet('woPriority.id', this.state) &&
		this.isTroubleshootingAllowedToProceed([WO_STEP_NAMES.PRIORITY]);

	render() {
		const {
			location,
			creating,
			formData,
			workOrderPriorities,
			fetchWorkOrderPriorities,
			fetchMultipleWorkOrderPriorities,
			supplierFacilities,
			fetchSupplierFacilitiesInPrivateNetwork,
			fetchMultipleSupplierFacilities,
			form,
			currentUser,
			addWarrantySupplier,
			match,
		} = this.props;
		const { getFieldDecorator, getFieldValue } = form;
		const {
			previewVisible,
			previewImage,
			showingAllSuppliers,
			currencyExchangeRateBuyerToLocation,
			supplier,
		} = this.state;
		const BACKEND_URI = getBackendUri();
		const uploadHeaders = { 'X-Auth-Token': retrieveCachedUserDetails(['token']).token };
		const isAdmin = currentUser.roles.some((role) => BUYER_ADMIN_ONLY.has(role));
		const { approvalHeirarchy, currencyExchangeRateLocationToSupplier } = this.state;
		const locationCurrency = getCurrency({ location: this.state.location });
		const supplierCurrency = getCurrency({ supplier: this.state.supplier });
		const workOrderCurrency = getCurrency({
			supplier: this.state.supplier,
			location: this.state.location,
		});
		const isSameCurrency = locationCurrency.id === supplierCurrency.id;

		const { locationTsAnswer, problemTypeTsAnswer, priorityTsAnswer } =
			getTroubleshootingAnswersForNecessaryWOSteps(this.state);

		const workOrderDetails = [
			{ key: 'Location', value: nullSafeGetOrElse('name', this.state.location, '') },
			...locationTsAnswer,
			{ key: 'Area', value: nullSafeGetOrElse('area.hierarchyName', this.state.asset, '') },
			{
				key: 'Problem Type',
				value: nullSafeGetOrElse('hierarchyName', this.state.problemType, ''),
			},
			...problemTypeTsAnswer,
			{ key: 'Asset', value: nullSafeGetOrElse('name', this.state.asset, '') },
			...(nullSafeGetOrElse('name', this.state.asset, '')
				? [
						{
							key: 'Is the Asset Under Warranty?',
							value: checkIsWarrantyWorkOrder(
								nullSafeGet('asset.warranties.0', this.state),
								nullSafeGet('id', this.state.supplier)
							)
								? 'Yes'
								: 'No',
						},
						{
							key: 'Is the Asset functioning?',
							value: formData.isAssetDown === 'true' ? 'No' : 'Yes',
						},
				  ]
				: []),
			{ key: 'Title', value: nullSafeGetOrElse('title', formData, '') },
			{ key: 'Priority', value: nullSafeGetOrElse('woPriority.name', this.state, '') },
			...priorityTsAnswer,
			{ key: 'Submitted By', value: nullSafeGetOrElse('submittedByName', formData, '') },
			{ key: 'Service Provider', value: nullSafeGetOrElse('supplier.name', this.state, '') },
			...(this.state.nte
				? [
						{
							key: 'NTE',
							value: workOrderCurrency.format(
								this.state.nte * currencyExchangeRateLocationToSupplier
							),
						},
				  ]
				: []),
		];

		const photoStrings = (getFieldValue('images') || []).map((p) => {
			const fileName = nullSafeGetOrElse('response.data.fileName', p, '');
			const fileId = nullSafeGetOrElse('response.data.fileId', p, '');
			return `${fileId}/${fileName}`;
		});

		const isImageUploading = (getFieldValue('images') || []).some((_) => _.status === 'uploading');
		const isProcessing = this.isProcessing();

		const minPhotosCount = nullSafeGetOrElse('state.numPicturesRequired', this, 0);

		const imageCountErrorMessage = `You need to upload at least ${minPhotosCount} photo${
			minPhotosCount > 1 ? 's' : ''
		}`;

		const imageCountMatched =
			minPhotosCount <= nullSafeGetOrElse('length', getFieldValue('images'), 0);

		const getTroubleshootingSteps = () => {
			const troubleshootingRoutes = nullSafeGetOrElse('state.troubleshootingRoutes', this, []);
			return troubleshootingRoutes.reduce((steps, route) => {
				const existingAnswer = getExistingTsAnswersFromStateForWOTsRoute(this.state, route);
				return {
					...steps,
					[`troubleshooting-${route.id}`]: {
						id: `t-${route.id}`,
						label: 'Troubleshooting',
						component: (
							<TroubleshootingDisplay
								troubleshootingSteps={route.troubleshootingSteps}
								onBack={this.goBack}
								onNextStep={(answers) => {
									if (nullSafeGet('0', answers)) {
										const troubleshootingAnswers = getUpdatedTsAnswersState(
											this.state,
											route,
											answers
										);
										this.setState({ troubleshootingAnswers });
									}
									route.args && this.proceedToNextStep(route.args);
								}}
								onCancel={this.cancelRequest}
								existingAnswer={existingAnswer}
							/>
						),
					},
				};
			}, {});
		};

		const defaultNavMenuSteps = [
			...(this.state.asset
				? [
						{
							title: 'assetCondition',
							enabled: true,
						},
				  ]
				: []),
			{
				title: 'problemTypeTopLevel',
			},
			...(this.state.problemTypeLevel2Available
				? [
						{
							title: 'problemTypeNextLevel',
							enabled: true,
						},
				  ]
				: []),
			...(this.state.problemTypeLevel3Available
				? [
						{
							title: 'problemTypeNextBranch',
							enabled: true,
						},
				  ]
				: []),
			{
				title: 'title',
				enabled: this.isProblemTypeAndAssetSelected(),
			},
			{
				title: 'photos',
				enabled: this.isProblemTypeAndAssetSelected() && nullSafeGet('title', formData),
			},
			{
				title: 'priority',
				enabled:
					this.isProblemTypeAndAssetSelected() &&
					nullSafeGet('title', formData) &&
					imageCountMatched,
			},
			{
				title: 'supplier',
				enabled:
					this.isProblemTypeAndAssetSelected() &&
					nullSafeGet('title', formData) &&
					imageCountMatched &&
					this.isPrioritySelected(),
			},
			{
				title: 'nte',
				enabled:
					this.isProblemTypeAndAssetSelected() &&
					nullSafeGet('title', formData) &&
					imageCountMatched &&
					this.isPrioritySelected(),
			},
			...(nullSafeGetOrElse('isSharedContact', currentUser, false)
				? [
						{
							title: WO_STEP_NAMES.SUBMITTED_BY,
							enabled:
								this.isProblemTypeAndAssetSelected() &&
								nullSafeGet('title', formData) &&
								imageCountMatched &&
								this.isPrioritySelected(),
						},
				  ]
				: []),
			{
				title: 'completion',
				enabled:
					this.isProblemTypeAndAssetSelected() &&
					nullSafeGet('title', formData) &&
					imageCountMatched &&
					this.isPrioritySelected(),
			},
		];

		const getNavSteps = () => {
			const allNavSteps = mergeTroubleshootingRoutes(
				defaultNavMenuSteps,
				nullSafeGetOrElse('state.troubleshootingRoutes', this, []),
				(route) => defaultNavMenuSteps.map((_) => _.title).indexOf(route.previousStep),
				(route) => ({
					title: `troubleshooting-${route.id}`,
					enabled: true,
				})
			);

			return allNavSteps;
		};

		const defaultSteps = {
			assetCondition: {
				id: 1,
				label: 'Asset Status',
				component: (
					<div key={8} className="newWorkOrderWizardPage__section">
						<h3 className="newWorkOrderWizardPage__title" style={{ marginBottom: 16 }}>
							{`Is the asset functioning?`}
						</h3>
						<Form.Item style={{ width: '100%' }}>
							{getFieldDecorator(`isAssetDown`, {
								initialValue: nullSafeGetOrElse('isAssetDown', formData, ''),
							})(
								<OWRadio
									fieldName="assetId"
									onChange={this.handleAssetCondition}
									onClick={this.handleAssetCondition}
									renderRecord={(location) => location.name}
									records={{
										false: {
											id: 'false',
											name: 'Yes',
										},
										true: {
											id: 'true',
											name: 'No',
										},
									}}
									sorter={(records) => records.sort((a, b) => (a.id > b.id ? 1 : -1))}
								/>
							)}
						</Form.Item>
					</div>
				),
			},
			problemTypeTopLevel: {
				id: 2,
				label: 'Problem Type',
				component: (
					<div key={5} className="newWorkOrderWizardPage__section">
						<h3 className="newWorkOrderWizardPage__title">What kind of request is it?</h3>
						<Form.Item className={'flex w-full flex-grow'}>
							{getFieldDecorator(`problemTypeTopLevel`, {
								rules: [
									{
										required: false,
									},
								],
								initialValue: nullSafeGet('problemTypeLevel1Id', this.state),
							})(
								<OWRadio
									autoPickFirstOption
									getDescription={(record) => record.description}
									fieldName="problemTypeTopLevel"
									onChange={this.handleProblemTypeTopLevelChange}
									onClick={this.handleProblemTypeTopLevelChange}
									renderRecord={(pt) => pt.name}
									records={nullSafeGetOrElse(
										`state.currentProblemTypes.${WO_STEP_NAMES.PROBLEM_TYPE_TOP_LEVEL}`,
										this,
										[]
									)}
									sorter={(records) => records.sort((a, b) => (a.id > b.id ? 1 : -1))}
								/>
							)}
						</Form.Item>
						<Button
							size="large"
							type="ghost"
							onClick={() => this.goBack()}
							loading={isProcessing}
							disabled={isProcessing}
						>
							Back
						</Button>
					</div>
				),
			},
			problemTypeNextLevel: {
				id: 3,
				label: 'Problem Type - 2',
				component: (
					<div key={6} className="newWorkOrderWizardPage__section">
						<h3 className="newWorkOrderWizardPage__title px-2">What kind of request is it?</h3>
						<Form.Item className={'flex w-full flex-grow'}>
							{getFieldDecorator(`problemTypeId`, {
								rules: [
									{
										required: false,
									},
								],
								initialValue: nullSafeGet('problemTypeLevel2Id', this.state),
							})(
								nullSafeGet('currentRoute', this.state) === 'problemTypeNextLevel' ? (
									<OWRadio
										autoPickFirstOption
										getDescription={(record) => record.description}
										fieldName="problemTypeId"
										onChange={this.handleProblemTypeNextLevelChange}
										onClick={this.handleProblemTypeNextLevelChange}
										renderRecord={(pt) => pt.name}
										records={nullSafeGetOrElse(
											`state.currentProblemTypes.${WO_STEP_NAMES.PROBLEM_TYPE_NEXT_LEVEL}`,
											this,
											[]
										)}
										sorter={(records) => records.sort((a, b) => (a.id > b.id ? 1 : -1))}
									/>
								) : (
									<div />
								)
							)}
						</Form.Item>
						<Button
							size="large"
							type="ghost"
							onClick={() => this.goBack()}
							loading={isProcessing}
							disabled={isProcessing}
						>
							Back
						</Button>
					</div>
				),
			},
			problemTypeNextBranch: {
				id: 4,
				label: 'Problem Type - 3',
				component: (
					<div key={7} className="newWorkOrderWizardPage__section">
						<h3 className="newWorkOrderWizardPage__title">What kind of request is it?</h3>
						<Form.Item style={{ width: '100%' }}>
							{getFieldDecorator(`problemTypeIdNextLevel`, {
								rules: [
									{
										required: false,
									},
								],
								initialValue: nullSafeGet('problemTypeLevel3Id', this.state),
							})(
								nullSafeGet('currentRoute', this.state) === 'problemTypeNextBranch' ? (
									<OWRadio
										autoPickFirstOption
										getDescription={(record) => record.description}
										fieldName="problemTypeIdNextLevel"
										onChange={this.handleProblemTypeNextLevelBranchChange}
										onClick={this.handleProblemTypeNextLevelBranchChange}
										renderRecord={(pt) => pt.name}
										records={nullSafeGetOrElse(
											`state.currentProblemTypes.${WO_STEP_NAMES.PROBLEM_TYPE_NEXT_BRANCH}`,
											this,
											[]
										)}
										sorter={(records) => records.sort((a, b) => (a.id > b.id ? 1 : -1))}
									/>
								) : (
									<div />
								)
							)}
						</Form.Item>
						<Button
							size="large"
							type="ghost"
							onClick={() => this.goBack()}
							loading={isProcessing}
							disabled={isProcessing}
						>
							Back
						</Button>
					</div>
				),
			},
			title: {
				id: 5,
				label: 'Description',
				component: (
					<div key={9} className="newWorkOrderWizardPage__section">
						<h3 className="newWorkOrderWizardPage__title">
							In a few words, what's this request about?
						</h3>
						<Form.Item style={{ width: '100%', marginBottom: 40 }}>
							{getFieldDecorator(`title`, {
								rules: [{ required: true, message: 'Please describe the request.' }],
								initialValue: nullSafeGet('title', formData),
							})(
								<Input.TextArea
									autoSize
									showCount
									maxLength={120}
									style={{ width: '100%', marginBottom: 40 }}
									size="large"
								/>
							)}
						</Form.Item>
						<div className="flex flex-row">
							<Button
								size="large"
								type="ghost"
								onClick={() => this.goBack()}
								loading={isProcessing}
								disabled={isProcessing}
							>
								Back
							</Button>
							<Button
								size="large"
								type="primary"
								className="ml-4"
								disabled={isProcessing}
								loading={isProcessing}
								onClick={() => this.handleTitle()}
							>
								Next step
							</Button>
						</div>
					</div>
				),
			},
			duplicateCheck: {
				id: 21,
				label: 'Possible Duplicates',
				component: (
					<div key={11} className="newWorkOrderWizardPage__section">
						<h3 className="newWorkOrderWizardPage__title">
							We found potential duplicate requests. Do you still want to open a new request?
						</h3>
						<Table
							pagination={false}
							showHeader={false}
							dataSource={nullSafeGetOrElse('duplicateWorkOrders', this.state, [])}
							columns={DUPLICATE_WORK_ORDER_COLUMNS}
						/>
						<Form.Item style={{ width: '100%' }}>
							{getFieldDecorator(`isDuplicate`, {
								initialValue: nullSafeGet('isDuplicate', formData),
							})(
								<OWRadio
									fieldName="isDuplicate"
									onChange={this.handleDuplicate}
									onClick={this.handleDuplicate}
									renderRecord={(option) => option.name}
									records={{
										1: { id: 1, name: 'No, cancel this request' },
										2: { id: 2, name: 'Yes, this is a different issue' },
									}}
									sorter={(records) => records.sort((a, b) => (a.id > b.id ? 1 : -1))}
								/>
							)}
						</Form.Item>
						<Button
							size="large"
							type="ghost"
							onClick={() => this.goBack()}
							loading={isProcessing}
							disabled={isProcessing}
						>
							Back
						</Button>
					</div>
				),
			},
			photos: {
				id: 6,
				label: 'Photos',
				component: (
					<div key={10} className="newWorkOrderWizardPage__section">
						<h3 className="newWorkOrderWizardPage__title">Want to add some photos?</h3>
						<Form.Item
							style={{
								marginBottom: 20,
								width: '100%',
							}}
							className="text-center"
						>
							{getFieldDecorator(`images`, {
								valuePropName: 'fileList',
								getValueFromEvent: normFile,
								initialValue: this.state.allPhotos,
								rules: getImageCountErrorRules(minPhotosCount, imageCountErrorMessage),
							})(
								<OWUpload
									accept={imageWildcardUploadAccept}
									name="file"
									listType="picture-card"
									className="workorder-image-uploader"
									multiple={true}
									headers={uploadHeaders}
									onPreview={this.handlePreview}
									action={`${BACKEND_URI}/api/v1/buyer/file/upload`}
									beforeUpload={imageUploadValidation}
									onChange={this.handleImageUpdate}
								>
									<div style={{ display: 'inline' }}>
										<LegacyIcon type={this.state.uploadLoading ? 'loading' : 'plus'} />
										<div className="ant-upload-text">Upload</div>
									</div>
									<Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
										<ResolvedImage
											url={previewImage || ''}
											style={{ width: '100%', objectFit: 'contain' }}
											preview={false}
										/>
									</Modal>
								</OWUpload>
							)}
						</Form.Item>
						<div className="flex flex-row">
							<Button
								size="large"
								type="ghost"
								onClick={() => this.goBack()}
								loading={isProcessing}
								disabled={isProcessing}
							>
								Back
							</Button>
							<Button
								size="large"
								type="primary"
								className="ml-4"
								loading={isImageUploading || isProcessing}
								disabled={isProcessing}
								onClick={() =>
									this.goNextAfterBriefPause(['images'], 'priority', WO_STEP_NAMES.PHOTOS)
								}
							>
								Next step
							</Button>
						</div>
					</div>
				),
			},
			priority: {
				id: 7,
				label: 'Priority',
				component: (
					<div key={11} className="newWorkOrderWizardPage__section">
						<h3 className="newWorkOrderWizardPage__title">
							How quickly does this need to get fixed?
						</h3>
						<Form.Item
							style={{
								marginBottom: 20,
								width: '100%',
							}}
						>
							{getFieldDecorator(`woPriorityId`, {
								initialValue: nullSafeGet('woPriority.id', this.state),
							})(
								<OWAsyncRadio
									mode="default"
									fieldName="woPriorityId"
									stateSlice={workOrderPriorities}
									onChange={this.handleWorkOrderPriority}
									onClick={this.handleWorkOrderPriorityClick}
									targetCollectionName={'WORK_ORDER_FORM_WORK_ORDER_PRIORITIES_AUTOCOMPLETE'}
									fetchMultiple={(ids, targetCollectionName) =>
										fetchMultipleWorkOrderPriorities(ids, targetCollectionName)
									}
									fetchData={(
										searchText,
										targetCollectionName,
										pagination = null,
										sorting = {
											sort_by: 'expectedResolutionInSeconds',
											order: 'descend',
										},
										filters = null,
										addToTargetCollection = false
									) =>
										fetchWorkOrderPriorities(
											{ name: searchText },
											targetCollectionName,
											pagination,
											sorting,
											filters,
											addToTargetCollection
										)
									}
									renderRecord={(workOrderPriority) => workOrderPriority.name}
									keepFetchedOrder={true}
								/>
							)}
						</Form.Item>
						<div className="flex flex-row">
							<Button
								size="large"
								type="ghost"
								onClick={() => this.goBack()}
								loading={isProcessing}
								disabled={isProcessing}
							>
								Back
							</Button>
							<Button
								size="large"
								type="primary"
								className="ml-4"
								disabled={isProcessing}
								loading={isProcessing}
								onClick={() => {
									nullSafeGet('woPriority.id', this.state)
										? this.goNextAfterBriefPause([], 'supplier', WO_STEP_NAMES.PRIORITY)
										: message.error('Work order priority cannot be empty!');
								}}
							>
								Next step
							</Button>
						</div>
					</div>
				),
			},
			supplier: {
				id: 8,
				label: 'Service Provider',
				component: (
					<div key={12} className="newWorkOrderWizardPage__section">
						<h3 className="newWorkOrderWizardPage__title">
							Who do you want to get it assigned to?
						</h3>
						<div style={{ textAlign: 'center', marginBottom: 24 }}>
							<Button
								onClick={() => {
									this.setState({ supplier: null, skipSupplier: true }, () => {
										this.handleSupplierChange();
									});
								}}
								type="link"
								disabled={isProcessing}
							>
								Skip
							</Button>
						</div>
						<Form.Item
							style={{
								marginBottom: 20,
								width: '100%',
							}}
						>
							{getFieldDecorator(`supplierFacilityId`, {
								initialValue: nullSafeGet('supplier.id', this.state),
							})(
								<OWAsyncRadio
									keepFetchedOrder={!showingAllSuppliers}
									mode="default"
									fieldName="supplierFacilityId"
									stateSlice={supplierFacilities}
									onChange={this.handleSupplierChange}
									onClick={this.handleSupplierChange}
									orderRecords={(records) => {
										const assetSupplierId = getActiveAssetWarrantySupplierId(this.state.asset);
										const buildingSupplierId = getActiveBuildingWarrantySupplierId(
											this.state.location,
											nullSafeGet('problemType.id', this.state)
										);
										let ordered = records;
										if (assetSupplierId) {
											ordered = moveObjectToBeginning(ordered, 'id', assetSupplierId);
										}
										if (buildingSupplierId) {
											ordered = moveObjectToBeginning(ordered, 'id', buildingSupplierId);
										}
										return ordered;
									}}
									targetCollectionName={
										'WORK_ORDER_FORM_SUPPLIER_FACILITIES_IN_PRIVATE_NETWORK_AUTOCOMPLETE'
									}
									fetchMultiple={(ids, targetCollectionName) =>
										fetchMultipleSupplierFacilities(ids, targetCollectionName)
									}
									fetchData={(
										searchText,
										targetCollectionName,
										pagination = null,
										sorting = null,
										filters = null,
										addToTargetCollection = false
									) =>
										new Promise((resolve, reject) =>
											fetchSupplierFacilitiesInPrivateNetwork(
												{ name: searchText },
												targetCollectionName,
												pagination,
												sorting,
												showingAllSuppliers ? {} : filters,
												addToTargetCollection
											).then((data) => {
												const assetSupplierId = getActiveAssetWarrantySupplierId(this.state.asset);
												const buildingSupplierId = getActiveBuildingWarrantySupplierId(
													this.state.location,
													nullSafeGet('problemType.id', this.state)
												);
												const missing = [assetSupplierId, buildingSupplierId].filter(
													(id) => id && !data.some((supplier) => supplier.id === id)
												);
												if (missing.length === 0) {
													resolve(data);
												} else {
													let promise = Promise.resolve(data);
													missing.forEach((id) => {
														promise = promise.then(() =>
															addWarrantySupplier(
																id,
																'WORK_ORDER_FORM_SUPPLIER_FACILITIES_IN_PRIVATE_NETWORK_AUTOCOMPLETE'
															)
														);
													});
													promise.then((finalData) => resolve(finalData));
												}
											})
										)
									}
									renderRecord={(supplierFacility, apiSuppliers, searchText) => {
										const buildingSupplierId = getActiveBuildingWarrantySupplierId(
											this.state.location,
											nullSafeGet('problemType.id', this.state)
										);
										const assetSupplierId = getActiveAssetWarrantySupplierId(this.state.asset);
										const isBuilding = buildingSupplierId === supplierFacility.id;
										const isAsset = assetSupplierId === supplierFacility.id;
										return (
											<div>
												<Ellipsis
													tooltip={true}
													length={32}
													fullWidthRecognition={true}
													style={{ wordBreak: 'normal' }}
												>
													{supplierFacility.name}
												</Ellipsis>
												{isBuilding || isAsset ? (
													<span className="mt-0 inline-block  text-sm text-gray-400">
														{isBuilding ? '(Building Warranty)' : null}
														{isBuilding && isAsset ? ' ' : null}
														{isAsset ? '(Warranty)' : null}
													</span>
												) : (
													<p className={'mb-0'}>
														{!showingAllSuppliers &&
															!(searchText && searchText.length) &&
															(apiSuppliers.find((item) => item.id === supplierFacility.id) ? (
																<span className="mt-0 inline-block  text-sm text-gray-400">
																	(Rank{' '}
																	{apiSuppliers.findIndex(
																		(item, index) => supplierFacility.id === item.id
																	) + 1}
																	)
																</span>
															) : null)}
													</p>
												)}
											</div>
										);
									}}
									additionalFilters={{
										problemTypeId: nullSafeGet('problemType.id', this.state),
										locationId: nullSafeGet('location.id', this.state),
									}}
								/>
							)}
						</Form.Item>
						<Row style={{ flexDirection: 'column' }} align="middle">
							<Button
								size="large"
								type="ghost"
								icon={
									<Popover
										overlayStyle={{ zIndex: 1060 }}
										content={
											showingAllSuppliers
												? 'Click me to see only service providers which handle selected problem type and location'
												: 'Click me to see all your network service providers'
										}
									>
										<InfoCircleOutlined />
									</Popover>
								}
								onClick={() => {
									new Promise((resolve, reject) =>
										fetchSupplierFacilitiesInPrivateNetwork(
											'',
											'WORK_ORDER_FORM_SUPPLIER_FACILITIES_IN_PRIVATE_NETWORK_AUTOCOMPLETE',
											{ current: 1, pageSize: 250 },
											{},
											showingAllSuppliers
												? {
														problemTypeId: nullSafeGet('problemType.id', this.state),
														locationId: nullSafeGet('location.id', this.state),
												  }
												: {},
											false
										).then((data) => {
											const assetSupplierId = getActiveAssetWarrantySupplierId(this.state.asset);
											const buildingSupplierId = getActiveBuildingWarrantySupplierId(
												this.state.location,
												nullSafeGet('problemType.id', this.state)
											);
											const missing = [assetSupplierId, buildingSupplierId].filter(
												(id) => id && !data.some((supplier) => supplier.id === id)
											);
											if (missing.length === 0) {
												resolve(data);
											} else {
												let promise = Promise.resolve(data);
												missing.forEach((id) => {
													promise = promise.then(() =>
														addWarrantySupplier(
															id,
															'WORK_ORDER_FORM_SUPPLIER_FACILITIES_IN_PRIVATE_NETWORK_AUTOCOMPLETE'
														)
													);
												});
												promise.then((finalData) => resolve(finalData));
											}
										})
									);
									this.setState({ showingAllSuppliers: !showingAllSuppliers });
								}}
								style={{ marginBottom: 16 }}
							>
								{showingAllSuppliers ? 'Hide' : 'Show All'}
							</Button>
							<div className="flex flex-row">
								<Button
									size="large"
									type="ghost"
									onClick={() => this.goBack()}
									loading={isProcessing}
									disabled={isProcessing}
								>
									Back
								</Button>
								<Button
									size="large"
									type="primary"
									className="ml-4"
									disabled={isProcessing}
									loading={isProcessing}
									onClick={() => {
										this.handleSupplierChange();
									}}
								>
									Next step
								</Button>
							</div>
						</Row>
					</div>
				),
			},
			nte: {
				id: 9,
				label: 'NTE',
				component: (
					<div key={13} className="newWorkOrderWizardPage__section">
						<h3 className="newWorkOrderWizardPage__title">
							Would you like to set a Not-to-Exceed amount?
						</h3>
						<div style={{ display: 'flex', flexDirection: 'row', gap: 24 }}>
							<Form.Item
								validateStatus={approvalHeirarchy.status}
								help={
									approvalHeirarchy.status ? (
										<div
											style={{ width: '800px' }}
											className={'absolute flex flex-row flex-nowrap'}
										>
											{`This NTE change requires a quote. Based on approval hierarchy, you can set NTE upto ${locationCurrency.format(
												approvalHeirarchy.amount * currencyExchangeRateBuyerToLocation
											)}`}
										</div>
									) : (
										''
									)
								}
							>
								{getFieldDecorator(`nte`, {
									validateTrigger: 'onChange',
									rules: [
										{
											validator: (rule, value, callback) => {
												if (
													approvalHeirarchy.amount &&
													parseFloat(value) / currencyExchangeRateBuyerToLocation >
														parseFloat(approvalHeirarchy.amount) &&
													parseFloat(value) / currencyExchangeRateBuyerToLocation !== formData.nte
												) {
													this.setState({
														approvalHeirarchy: {
															...approvalHeirarchy,
															status: isAdmin ? 'warning' : 'error',
														},
													});
													callback(isAdmin ? undefined : '');
												} else {
													this.setState({
														approvalHeirarchy: {
															...approvalHeirarchy,
															status: null,
														},
													});
													callback();
												}
											},
										},
									],
									initialValue: nullSafeGet(`nte`, formData),
								})(
									<InputNumber
										placeholder="Enter a value.."
										style={{ width: '200px' }}
										size="large"
										addonAfter={locationCurrency.id}
										onChange={(value) => this.setNTE(value)}
									/>
								)}
							</Form.Item>
							{nullSafeGet('supplier.currencyId', this.state) && !isSameCurrency ? (
								<div style={{ display: 'flex', flexDirection: 'row' }}>
									<i
										className="icons8-font icons8-data-transfer flex"
										style={{ fontSize: 24, marginTop: 16, marginRight: 26 }}
									/>
									<InputNumber
										style={{ width: '200px' }}
										size="large"
										disabled={true}
										addonAfter={workOrderCurrency.id}
										value={(this.state.nte * currencyExchangeRateLocationToSupplier).toFixed(2)}
									/>
								</div>
							) : null}
						</div>
						<div className="flex flex-row pt-4">
							<Button
								size="large"
								type="ghost"
								onClick={() => this.goBack()}
								loading={isProcessing}
								disabled={isProcessing}
							>
								Back
							</Button>
							<Button
								size="large"
								type="primary"
								className="ml-4"
								disabled={isProcessing}
								loading={isProcessing}
								onClick={() => {
									this.handleNTESubmit();
									this.checkForSharedContactAndMoveToNextStep(['nte'], WO_STEP_NAMES.NTE);
								}}
							>
								Next step
							</Button>
						</div>
					</div>
				),
			},
			submittedBy: {
				id: 10,
				label: 'Submitted By',
				component: (
					<div key={15} className="newWorkOrderWizardPage__section">
						<h3 className="newWorkOrderWizardPage__title">Can you provide your name?</h3>
						<Form.Item style={{ width: '60%', marginBottom: 40 }}>
							{getFieldDecorator(`submittedByName`, {
								rules: [
									{
										required: this.state.submittedByNameIsRequired,
										message: 'Please provide your full name.',
									},
								],
								initialValue: nullSafeGet('submittedByName', formData),
							})(<Input size="large" />)}
						</Form.Item>
						<div className="flex flex-row">
							<Button
								size="large"
								type="ghost"
								onClick={() => this.goBack()}
								loading={isProcessing}
								disabled={isProcessing}
							>
								Back
							</Button>
							<Button
								size="large"
								type="primary"
								className="ml-4"
								disabled={isProcessing}
								loading={isProcessing}
								onClick={() =>
									this.goNextAfterBriefPause(
										['submittedByName'],
										WO_STEP_NAMES.COMPLETION,
										WO_STEP_NAMES.SUBMITTED_BY
									)
								}
							>
								Next step
							</Button>
						</div>
					</div>
				),
			},
			completion: {
				id: 11,
				label: 'Summary',
				component: (
					<div key={14} className="newWorkOrderWizardPage__section" style={{ width: '100%' }}>
						<h3 className="newWorkOrderWizardPage__title">Summary</h3>
						<div style={{ marginBottom: 24, maxWidth: '60%' }}>
							<WorkOrderSummary workOrderDetails={workOrderDetails} photoStrings={photoStrings} />
						</div>
						<div className="flex flex-row">
							<Button
								size="large"
								type="ghost"
								onClick={() => this.goBack()}
								loading={isProcessing}
								disabled={isProcessing}
							>
								Back
							</Button>
							<Button
								className="ml-4"
								onClick={this.handleSubmit}
								type="primary"
								size="large"
								loading={isProcessing}
								disabled={isProcessing}
							>
								Create Work Order
							</Button>
						</div>
					</div>
				),
			},
		};

		const getSteps = () => {
			const allStepKeys = mergeTroubleshootingRoutes(
				Object.keys(defaultSteps),
				nullSafeGetOrElse('state.troubleshootingRoutes', this, []),
				(route) => Object.keys(defaultSteps).indexOf(route.previousStep),
				(route) => `troubleshooting-${route.id}`
			);

			const troubleshootingSteps = getTroubleshootingSteps();

			const allSteps = allStepKeys.reduce((steps, key) => {
				return {
					...steps,
					[key]: key.startsWith('troubleshooting') ? troubleshootingSteps[key] : defaultSteps[key],
				};
			}, {});

			return allSteps;
		};

		const allNavSteps = getNavSteps();
		const currentStepKey = location.pathname.split('/')[location.pathname.split('/').length - 1];
		const currentStepIndex = allNavSteps.map((_) => _.title).indexOf(currentStepKey);
		const currentCompletionPercentage = ((currentStepIndex * 1.0) / allNavSteps.length) * 100;

		const assetId = match.params.id;

		return (
			<div className="newWorkOrderWizardPage">
				<Drawer
					width={240}
					title="Overview"
					bodyStyle={{ padding: '16px 0' }}
					placement="left"
					closable={true}
					onClose={this.handleNavMenuClose}
					visible={this.state.navMenuVisible}
				>
					<Menu
						onClick={this.handleNavMenuClick}
						style={{ width: 240 }}
						defaultSelectedKeys={[currentStepKey]}
						mode="inline"
					>
						{allNavSteps.map((k) => {
							const step = getSteps()[k.title];
							return (
								<Menu.Item disabled={!k.enabled || isProcessing} key={k.title}>
									{step.label}
								</Menu.Item>
							);
						})}
					</Menu>
				</Drawer>
				<div
					style={{
						position: 'absolute',
						display: 'flex',
						alignItems: 'center',
						zIndex: 3,
						right: 16,
						top: 8,
					}}
				>
					<Button type="link" onClick={this.cancelRequest}>
						Cancel Request
					</Button>
				</div>
				<div className="newWorkOrderWizardPage__inner">
					{Object.keys(getSteps()).map((k) => {
						const step = getSteps()[k];
						const path = `/buyer/assets/${assetId}/newWorkOrder/${k}`;
						return <Route key={step.id} path={path} render={() => step.component} exact={true} />;
					})}
				</div>
				<div
					style={{
						position: 'absolute',
						display: 'flex',
						alignItems: 'center',
						zIndex: 3,
						left: 0,
						right: 0,
						bottom: 0,
						backgroundColor: 'white',
						border: '1px solid #f5f5f5',
						width: '100%',
					}}
				>
					<Button
						style={{ display: 'inline-block', margin: '8px 16px 8px 8px' }}
						size="large"
						icon={<MenuOutlined />}
						onClick={this.handleNavMenuOpen}
					>
						Overview
					</Button>
					<Progress
						style={{ margin: '8px 16px 8px 8px' }}
						strokeLinecap="square"
						strokeColor="#6027b0"
						percent={currentCompletionPercentage}
						showInfo={false}
					/>
				</div>
				{this.state.selfManagedSupplierEmailModalVisible && (
					<SelfManagedSupplierEmailPromptModal
						visible
						showContext
						supplierFacility={this.state.supplier}
						onSkip={this.handleSelfManagedSupplierEmailSkipped}
						onInvited={this.handleSelfManagedSupplierEmailInvited}
					/>
				)}
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	redirectForwardUrl: ownProps.redirectForwardUrl,
	formData: state.work_orders.formData,
	currentUser: state.session.currentUser,
	companyConfig: state.company_config.detail,
	creating: state.work_orders.creating,
	workOrderPriorities: state.work_order_priorities,
	supplierFacilities: state.supplier_facilities,
	location: ownProps.location,
});

const mapDispatchToProps = (dispatch) => ({
	saveFormData: (formData) => dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.saveFormData(formData)),
	clearFormData: () => dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.clearFormData()),
	fetchWorkOrderPriority: (id) => dispatch(workOrderPrioritiesRestCrudThunksForBuyer.readOne(id)),
	fetchWorkOrderPriorities: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			workOrderPrioritiesWithoutPMRestCrudThunksForBuyer.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleWorkOrderPriorities: (ids, targetCollectionName) =>
		dispatch(workOrderPrioritiesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
	fetchBuyer: (id) => dispatch(buyersRestCrudThunksForBuyer.readOne(id)),
	fetchLocation: (id) => dispatch(locationsRestCrudThunksForBuyer.readOne(id)),
	fetchAsset: (id) => dispatch(assetsRestCrudThunksForBuyer.readOne(id)),
	fetchProblemType: (id) => dispatch(problemTypesRestCrudThunksForBuyer.readOne(id)),
	fetchProblemTypesHierarchical: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			problemTypesHeirarchicalForBuyer(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchSupplierFacility: (id) => dispatch(supplierFacilitiesRestCrudThunksForBuyer.readOne(id)),
	fetchSupplierRelationship: (params) => dispatch(supplierPrivateNetworksV2ForBuyer(params)),
	fetchSupplierFacilitiesInPrivateNetwork: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			fetchSupplierFacilitiesInPrivateNetworkForBuyer(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleSupplierFacilities: (ids, targetCollectionName) =>
		dispatch(supplierFacilitiesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
	fetchWorkOrderAttributes: (params) =>
		dispatch(workOrderAttributesRestCrudThunksForBuyer.read(params)),
	submitWorkOrderForm: (workOrder) => dispatch(workOrdersRestCrudThunksForBuyer.create(workOrder)),
	addWarrantySupplier: (supplierId, targetCollectionName) =>
		dispatch(addWarrantySupplierToStoreState(supplierId, targetCollectionName)),
	roleUpdateUser: (entity) => dispatch(buyerRoleUpdateUser(entity)),
	fetchApprovalHeirarchy: (id) => dispatch(getBuyerCompanyApprovalTiers(ROLE_TYPES.BUYER, null)()),
	fetchExchangeRate: (c1, c2, userType) => dispatch(getExchangeRate(c1, c2)(userType)),
	fetchTroubleshooting: (params) => dispatch(troubleshootingRestCrudThunksForBuyer.read(params)),
	createTroubleshootingAnswersBulk: (entities) =>
		dispatch(troubleshootingAnswersRestCrudThunksForBuyer.createBulk(entities)),
	fetchWorkOrders: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			workOrdersRestCrudThunksForBuyer.searchAndHydrate(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection,
				workOrderSearchAndAPIAdaptor
			)
		),
	deleteWorkOrderFromRedux: (entity) =>
		dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.deleteSuccess(entity)),
	fetchArea: (id) => dispatch(areasRestCrudThunksForBuyer.readOne(id)),
	findDuplicateWorkOrders: (params) => findDuplicateWorkOrdersForBuyer(params),
});

export default withRouter<any, any>(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(
		Form.create<NewWorkOrderWizardProps>({
			onValuesChange: (props, changedFields) => {
				props.saveFormData(changedFields);
			},
		})(NewWorkOrderWizardPage)
	)
);
